/**
 * page11 (#433/#438) — worksheet státusz-történet hook (use-contact-persons minta).
 * Lazy: `worksheetId === undefined` esetén nem fetchel (a DetailPage csak az
 * aktív history-tabon adja át az id-t — felesleges hívás és spec-blast nélkül).
 */

import { getWorksheetStatusHistory, type WorksheetStatusHistoryEntryDto } from '@/api/worksheets';
import { useCallback, useEffect, useState } from 'react';

export function useWorksheetStatusHistory(worksheetId: string | undefined): {
  entries: WorksheetStatusHistoryEntryDto[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
} {
  const [entries, setEntries] = useState<WorksheetStatusHistoryEntryDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = useCallback(async () => {
    if (!worksheetId) {
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      setEntries(await getWorksheetStatusHistory(worksheetId));
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch status history';
      setError(message);
      console.error('Error fetching worksheet status history:', err);
    } finally {
      setIsLoading(false);
    }
  }, [worksheetId]);

  useEffect(() => {
    void fetchHistory();
  }, [fetchHistory]);

  return { entries, isLoading, error, refetch: fetchHistory };
}
